<template>
  <div class="card1 card card-stats mb-4 mb-lg-0">
    <div class="card-body1 card-body">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="text-left col-8">
                        <h5 class="card-title text-uppercase text-muted mb-0">Ejercicio</h5>
                    </div>
                    <div class="text-right col-4">
                        <div class="row">
                            <base-button v-if="showDelete" type="danger" size="sm" @click="deleteEjercicio(uid)"><i class="ni ni-fat-delete" aria-hidden="true"></i></base-button>
                        </div>
                        
                        
                    </div> 
                </div>
                <span class="h2 font-weight-bold mb-0">{{ejercicio_name}}</span>
            </div>

        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
            <table>
                <tr>
                    <th>Series: </th><td style="text-align:right;">{{series}}</td>
                </tr>
                <tr>
                    <th>Repeticiones: </th><td style="text-align:right;">{{repeticiones}}</td>
                </tr>
                <tr>
                    <th>Descanso(s): </th><td style="text-align:right;">{{descanso}}</td>
                </tr>
            </table>
        </p>
        <br>
        <div>
            <router-link :to="{ name: 'Ver Ejercicio', params: { ejercicioId: ejercicio_id}}" class="btn btn-block btn-primary mb-3">
                Ver ejercicio
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
import { db } from '../firebaseDb';
import { auth } from '../firebaseDb';
export default {
    name: "ejercicio-card",
    props: {
        series: {
            type: Number,
            description: "Series del ejercicio"
        },
        repeticiones: {
            type: Number,
            description: "Reps del ejercicio"
        },
        descanso: {
            type: String,
            description: "Descanso del ejercicio"
        },
        ejercicio_id: {
            type: String,
            description: "ID del ejercicio"
        },
        rutina_id: {
            type: String,
            description: "ID de la rutina"
        },
        uid:{
             type: String,
            description: "ID del ejercicio la rutina"
        },showDelete:{
            type: Boolean,
            description: "Activar o desactivar el botón de borrar",
            default: false
        }
    },
    data() {
        return {
            ejercicio_name: "",
            user: auth.currentUser,
        }
    },
    created: function() {
         db.collection('ejercicios').doc(this.ejercicio_id).get()
            .then(res => {
              let ejercicio = res.data()
              this.ejercicio_name = ejercicio.ejercicio_name
              this.track();
            })
            .catch(err => console.error(err));
    },
    methods: {
      deleteEjercicio(id){
        if (window.confirm("¿Está seguro de eliminar este ejercicio de la rutina?")) {
          db.collection("users").doc(this.user.uid).collection('rutinas').doc(this.rutina_id).collection('ejercicios').doc(id).delete().then(() => {
              console.log("Document deleted!");
              this.$router.go(0);
          })
          .catch((error) => {
              console.error(error);
          })
        }
      },
      track() {
        this.$gtag.event("seen_exercise_from_card", {
          'event_category': "exercise",
          'event_label': "exercise_seen_from_card",
          'value': 1
        })
      },
    } 
};
</script>

<style>
img{
  max-width: 95%;
}
#container-ejercicios{
    overflow-x: auto;
    white-space: nowrap;
}
.card-body1{
    overflow-x:initial;
    white-space: initial;
}
.card1{
    min-width: 195px;
    min-height: 250px;
}
</style>